import { Injectable } from "@angular/core";
import { CanActivate, Router } from "@angular/router";
import { Capacitor } from "@capacitor/core";
import { PermissionEnum } from "../model/permission-enum";
import { AuthenticationService } from "../services/authentication.service";

@Injectable({ providedIn: "root" })
export class NativeAdminStartGuard implements CanActivate {
  constructor(
    private router: Router,
    private authenticationService: AuthenticationService,
  ) {}

  async canActivate(): Promise<boolean> {
    if (!Capacitor.isNativePlatform()) {
      return true;
    }

    await this.authenticationService.waitForInitialization();

    if (!this.hasAdminPermission()) {
      return true;
    }

    this.router.navigate(["/employee-interface"], { replaceUrl: true });
    return false;
  }

  private hasAdminPermission(): boolean {
    return this.authenticationService.currentUserPermissions.some(
      (permission: PermissionEnum) => permission == PermissionEnum.Admin,
    );
  }
}
